module.exports = __webpack_public_path__ + "img/阳光公开.c842b50b.png";